export const ROOT_PATH = '/';
export const APPLICATION_URL = process.env.REACT_APP_DAVINCI_FRONTEND_BASE_URL;
